import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ApplicationClientCommonModule } from '@sdbn/common';
import { CommonTranslationModule } from '@sdbn/common';
import { DictionaryModule } from '@sdbn/common';

import { TaskStateIconComponent } from './icons/task-state-icon/task-state-icon.component';
import { TransportScopeIconComponent } from './icons/transport-scope-icon/transport-scope-icon.component';
import { StationTileComponent } from './station-tile/station-tile.component';

@NgModule({
  declarations: [
    TransportScopeIconComponent,
    TaskStateIconComponent,
    StationTileComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,

    DictionaryModule,
    ApplicationClientCommonModule,
    CommonTranslationModule
  ],
  exports: [
    TransportScopeIconComponent,
    TaskStateIconComponent,
    StationTileComponent
  ]
})
export class TmcYardCommonModule { }
